module.exports = __webpack_public_path__ + "static/media/Coming.56f3a0e7.png";